import{a as e}from"./chunk-UT3L3KPH.mjs";import{b as m}from"./chunk-DFUGJHJ2.mjs";import{j as r,k as o}from"./chunk-HXJ5NQSR.mjs";var i=new r({locale:[e,m,o]});export{i as a};
